import { Injectable } from '@angular/core';

@Injectable()
export class CacheService {
  private _cache = {};

  public save<T>(key: string, data: T): void {
    this._cache[key] = data;
  }

  public has(key) {
    return key in this._cache;
  }

  public get<T>(key): T {
    return this._cache[key];
  }
}
